<template>
  <div class="container">
    <div class="w-full">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>

export default {
  name: 'FestivalModule',
  data: () => ({
    // festivals: this.$store.
  }),
  computed: {
  },
  methods: {},
  mounted() {
    this.$store.dispatch('getFestival', { festival: { id: this.$route.params.id } })
  }
}
</script>
